<template>
	<section>
		<el-tabs v-model="activeName" type="card">
			<!--open list-->
			<el-tab-pane label="Open" name="first">
				<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
					<el-form :inline="true" :model="filters">
						<el-form-item>
							<el-input v-model="filters.openOfferFilter" placeholder="Product Name or UPC" clearable @keyup.enter.native="getOpenOffers">
								<el-button slot="append" icon="el-icon-search" @click="getOpenOffers"></el-button>
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="exportExcel('/excel/exportOfferOpen','Active Offer.xls')">Export</el-button>
						</el-form-item>
						<el-form-item class="pull-right">
							<el-button type="primary" @click="showAddProduct">Add Offer</el-button>
						</el-form-item>
					</el-form>
				</el-col>

				<!--列表-->
				<el-table stripe :data="openOffers" highlight-current-row v-loading="firstListLoading"  style="width: 100%;">
					<el-table-column label="#" prop="offerNo" width="80px">
					</el-table-column>
					<el-table-column label="Offer" width="300px">
						<template slot-scope="scope">
							{{scope.row.productName}}
							<div class="note" v-html="scope.row.note"></div>
						</template>
					</el-table-column>
					<el-table-column prop="price" label="Price"  >
					</el-table-column>
					<el-table-column prop="bouns" label="Bonus"  >
					</el-table-column>
					<el-table-column prop="quantity" label="Total"  >
					</el-table-column>
					<el-table-column prop="leftNum" label="Left"  >
					</el-table-column>
					<el-table-column prop="createDate" label="Date Created"  >
					</el-table-column>
					<el-table-column prop="expireDate" label="Expiration Date"  >
					</el-table-column>
					<el-table-column label="Action" width="300">
						<template slot-scope="scope">
							<el-button size="small" @click="showEditOffer(scope.row.offerNo)">Edit</el-button>
							<el-button size="small" @click="archiveOffer(scope.row.offerNo)">Archived</el-button>
							<el-button size="small" @click="showOfferClaimDetails(scope.row.offerNo)">Claims</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!--工具条-->
				<el-col :span="24" class="toolbar">
					<el-pagination layout="prev, pager, next" @current-change="handleChangeOpenOffer" :page-size="pageSize" :total="openOfferTotal" style="float:right;">
					</el-pagination>
				</el-col>
			</el-tab-pane>
			<!--proposed offer list-->
			<el-tab-pane label="Proposed" name="second">
				<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
					<el-form :inline="true" :model="filters">
						<el-form-item>
							<el-input v-model="filters.proposedFilter" placeholder="Product Name or UPC" clearable @keyup.enter.native="getProposedOffers">
								<el-button slot="append" icon="el-icon-search" @click="getProposedOffers"></el-button>
							</el-input>
						</el-form-item>
						<el-form-item label="Status : " >
							<el-select v-model="filters.status" @change="getProposedOffers" clearable>
								<el-option label="Pending" value="0"></el-option>
								<el-option label="Confirmed" value="1"></el-option>
								<el-option label="Rejected" value="2"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="exportExcel('/excel/exportOfferProposed','Proposed Offer.xls')">Export</el-button>
						</el-form-item>
					</el-form>
				</el-col>

				<!--列表-->
				<el-table stripe :data="proposedOffers" highlight-current-row v-loading="secondListLoading"  style="width: 100%;">
					<el-table-column prop="id" label="#">
					</el-table-column>
					<el-table-column prop="productName" label="Offer"  >
					</el-table-column>
					<el-table-column prop="user" label="User"  >
					</el-table-column>
					<el-table-column prop="price" label="Price"  >
					</el-table-column>
					<el-table-column prop="quantity" label="Qty"  >
					</el-table-column>
					<el-table-column label="Status">
						<template slot-scope="scope">
							<p v-if="scope.row.status===0"><el-tag type="info">Pending</el-tag></p>
							<p v-if="scope.row.status===1"><el-tag type="success">Confirmed</el-tag></p>
							<p v-if="scope.row.status===2"><el-tag type="danger">Rejected</el-tag></p>
							<p v-if="scope.row.status===3"><el-tag type="danger">cancelled</el-tag></p>
						</template>
					</el-table-column>
					<el-table-column prop="createDate" label="Date Created"  >
					</el-table-column>
					<el-table-column prop="expireDate" label="Offer Expiration Date"  >
					</el-table-column>
					<el-table-column label="Action" width="180">
						<template slot-scope="scope" v-if="scope.row.status===0">
							<el-button size="small" @click="confirmProposed(scope.row.id,1)">Confirm</el-button>
							<el-button size="small" type="danger" @click="confirmProposed(scope.row.id,2)">Reject</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!--工具条-->
				<el-col :span="24" class="toolbar">
					<el-pagination layout="prev, pager, next" @current-change="getProposedOffers" :page-size="pageSize" :total="proposedTotal" style="float:right;">
					</el-pagination>
				</el-col>
			</el-tab-pane>

			<!--offer history list-->
			<el-tab-pane label="Offer History" name="third">
				<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
					<el-form :inline="true" :model="filters">
						<el-form-item>
							<el-input v-model="filters.historyFilter" placeholder="Product Name or UPC" clearable @keyup.enter.native="getOfferHistory">
								<el-button slot="append" icon="el-icon-search" @click="getOfferHistory"></el-button>
							</el-input>
						</el-form-item>
						<el-form-item label="Status : ">
							<el-select v-model="filters.status" @change="getOfferHistory" clearable>
								<el-option label="Offering" value="offering"></el-option>
								<el-option label="Archived" value="archived"></el-option>
								<el-option label="Expired" value="expired"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="exportExcel('/excel/exportOfferHistory','Offer History.xls')">Export</el-button>
						</el-form-item>
					</el-form>
				</el-col>

				<!--列表-->
				<el-table stripe :data="offerHistory" highlight-current-row v-loading="thirdListLoading"  style="width: 100%;">
					<el-table-column label="#" prop="offerNo">
					</el-table-column>
					<el-table-column prop="productName" label="Product Name"  >
					</el-table-column>
					<el-table-column prop="price" label="Price"  >
					</el-table-column>
					<el-table-column prop="quantity" label="Total"  >
					</el-table-column>
                    <el-table-column prop="leftNum" label="Left"  >
                    </el-table-column>
					<el-table-column prop="createDate" label="Date Created"  >
					</el-table-column>
					<el-table-column prop="status" label="Status"  >
					</el-table-column>
					<el-table-column label="Action" width="280">
						<template slot-scope="scope">
							<el-button size="small" v-if="scope.row.status!='offering'" @click="reListOffer(scope.row.offerNo)">Relist</el-button>
							<el-button size="small" @click="getOfferDetail(scope.row.offerNo)">Detail</el-button>
							<el-button size="small" @click="showOfferClaimDetails(scope.row.offerNo)">Claims</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!--工具条-->
				<el-col :span="24" class="toolbar">
					<el-pagination layout="prev, pager, next" @current-change="handleChangeOfferHistory" :page-size="pageSize" :total="historyTotal" style="float:right;">
					</el-pagination>
				</el-col>
			</el-tab-pane>
		</el-tabs>

		<!--新增界面-->
		<el-dialog title="Add Offer" width="80%" :visible.sync="addFormVisible" :close-on-click-modal="false">
			<el-form :model="addOffer" label-width="220px" :rules="addOfferFormRules" ref="addOffer">
				<el-form-item label="Product" prop="productNo">
					<el-select v-model="addOffer.productNo" filterable auto-complete="off" clearable style="width:800px">
						<el-option v-for="(product,index) in products" :key="index" :value="product.productNo" :label="product.productName">{{product.condition+' - '+product.productName+' ('+product.createDate+')'}}</el-option>
					</el-select>
					<a @click="addProductVisible=true" style="margin-left: 20px;text-decoration: underline;color: blue;cursor: pointer">Add Product</a>
				</el-form-item>
				<el-form-item label="Price" prop="price">
					<el-input-number v-model="addOffer.price" :min="0"></el-input-number>
				</el-form-item>
				<el-form-item label="Total" prop="total">
					<el-input-number v-model="addOffer.total" :min="0"></el-input-number>
				</el-form-item>
				<el-form-item label="Expires At" prop="expireDate">
					<div class="block">
						<el-date-picker v-model="addOffer.expireDate" type="datetime"></el-date-picker>
					</div>
					<p class="note">By default, expires in 3 days</p>
				</el-form-item>
				<el-form-item label="Note" prop="note">
<!--					<el-input v-model="addOffer.note" type="textarea" rows="5" auto-complete="off"></el-input>-->
					<quill-editor v-model="addOffer.note" ref="myQuillEditor" :options="editorOption"></quill-editor>
				</el-form-item>
				<el-form-item label="Bonus" prop="bouns">
					<el-input-number v-model="addOffer.bouns" :min="0"></el-input-number>
				</el-form-item>
				<el-form-item label="" prop="scope">
					<el-radio-group v-model="addOffer.scope">
						<el-radio class="radio" label="public">public</el-radio>
						<el-radio class="radio" label="private">private</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="Users" v-if="addOffer.scope==='private'">
					<el-tree :data="groups" show-checkbox default-expand-all
							node-key="userNo" ref="tree" highlight-current :props="defaultProps">
					</el-tree>
					<!--<el-select v-model="addOffer.users" filterable multiple>
						<el-option-group
								v-for="(group,index) in groups"
								:key="index"
								:label="group.groupName">
							<el-option
									v-for="(member,index) in group.members"
									:key="index"
									:label="member.userName"
									:value="member.userNo">
							</el-option>
						</el-option-group>
					</el-select>-->
				</el-form-item>
				<el-form-item>
					<el-checkbox v-model="addOffer.notify">Notify every who can see the offer</el-checkbox>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addFormVisible = false">Close</el-button>
				<el-button type="primary" @click.native="handleAddOffer" :loading="loading">Submit</el-button>
			</div>
		</el-dialog>

		<!--修改界面-->
		<el-dialog title="Edit Offer" width="80%" :visible.sync="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editOffer" label-width="220px" :rules="editOfferFormRules" ref="editOffer">
				<el-form-item label="Product" prop="productNo">
					<el-select v-model="editOffer.productNo" :disabled="true" auto-complete="off">
						<el-option v-for="(product,index) in products" :key="index" :value="product.productNo" :label="product.productName">{{product.condition+' - '+product.productName+' ('+product.createDate+')'}}</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="Price" prop="price">
					<el-input-number v-model="editOffer.price" :min="0"></el-input-number>
				</el-form-item>
				<el-form-item label="Original Total" prop="quantity">
					<el-input-number v-model="editOffer.quantity" :min="0"></el-input-number>
				</el-form-item>
				<el-form-item label="Left" prop="leftNum">
					<el-input-number v-model="editOffer.leftNum" :min="0" :max="editOffer.quantity"></el-input-number>
				</el-form-item>
				<el-form-item label="Expires At" prop="expireDate">
					<div class="block">
						<el-date-picker v-model="editOffer.expireDate" type="datetime"></el-date-picker>
					</div>
					<p class="note">By default, expires in 3 days</p>
				</el-form-item>
				<el-form-item label="User" v-if="editOffer.scope=='private'">
					<el-tag type="info" v-for="(user,index) in editOffer.users" :key="index">{{user}}</el-tag>
				</el-form-item>
				<el-form-item label="Note" prop="note">
<!--					<el-input v-model="editOffer.note" type="textarea" rows="5" auto-complete="off"></el-input>-->
					<quill-editor v-model="editOffer.note" ref="myQuillEditor" :options="editorOption"></quill-editor>
				</el-form-item>
				<el-form-item label="Bonus" prop="bouns">
					<el-input-number v-model="editOffer.bouns" :min="0"></el-input-number>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">Close</el-button>
				<el-button type="primary" @click.native="handleEditOffer" :loading="loading">Submit</el-button>
			</div>
		</el-dialog>

		<el-dialog title="ReList Offer" width="80%" :visible.sync="relistFormVisible" :close-on-click-modal="false">
			<el-form :model="relistOffer" label-width="220px" :rules="editOfferFormRules" ref="relistOffer">
				<el-form-item label="Product" prop="productNo">
					<el-select v-model="relistOffer.productNo" :disabled="true" auto-complete="off">
						<el-option v-for="(product,index) in products" :key="index" :value="product.productNo" :label="product.productName">{{product.condition+' - '+product.productName+' ('+product.createDate+')'}}</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="Price" prop="price">
					<el-input-number v-model="relistOffer.price" :min="0"></el-input-number>
				</el-form-item>
				<el-form-item label="Original Total" prop="quantity">
					<el-input-number v-model="relistOffer.quantity" :min="0"></el-input-number>
				</el-form-item>
				<el-form-item label="Left" prop="leftNum">
					<el-input-number v-model="relistOffer.leftNum" :min="0" :max="relistOffer.quantity"></el-input-number>
				</el-form-item>
				<el-form-item label="Expires At" prop="expireDate">
					<div class="block">
						<el-date-picker v-model="relistOffer.expireDate" type="datetime" :disabled="true"></el-date-picker>
					</div>
				</el-form-item>
                <el-form-item label="New Expires At" prop="newExpireDate">
                    <div class="block">
                        <el-date-picker v-model="relistOffer.newExpireDate"  type="datetime"></el-date-picker>
                    </div>
                    <p class="note">By default, expires in 3 days</p>
                </el-form-item>
				<el-form-item label="User" v-if="relistOffer.scope=='private'">
					<el-tag type="info" v-for="(user,index) in relistOffer.users" :key="index">{{user}}</el-tag>
				</el-form-item>
				<el-form-item label="Note" prop="note">
					<quill-editor v-model="relistOffer.note" ref="myQuillEditor" :options="editorOption"></quill-editor>
				</el-form-item>
				<el-form-item label="Bonus" prop="bouns">
					<el-input-number v-model="relistOffer.bouns" :min="0"></el-input-number>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="relistFormVisible = false">Close</el-button>
				<el-button type="primary" @click.native="handleReListOffer" :loading="loading">Submit</el-button>
			</div>
		</el-dialog>

		<el-dialog title="Add Product" width="80%" :visible.sync="addProductVisible" :close-on-click-modal="false">
			<el-form :model="addProduct" label-width="220px" :rules="addProductFormRules" ref="addProduct">
				<el-form-item label="Name" prop="product">
					<el-input v-model="addProduct.product" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="Price" prop="price">
					<el-input-number :min="0" v-model="addProduct.price"></el-input-number>
				</el-form-item>
				<el-form-item label="Condition" prop="condition">
					<el-select v-model="addProduct.condition" auto-complete="off">
						<el-option v-for="(condition,index) in conditions" :key="index" :value="condition" :label="condition"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="ASIN" prop="asin">
					<el-input v-model="addProduct.asin"></el-input>
				</el-form-item>
				<el-form-item label="UPC" prop="upc">
					<el-input v-model="addProduct.upc"></el-input>
				</el-form-item>
				<el-form-item label="Weight" prop="weight">
					<el-input v-model="addProduct.weight"></el-input>
				</el-form-item>
				<el-form-item label="Note" prop="note">
					<el-input v-model="addProduct.note" type="textarea" rows="5" auto-complete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addProductVisible = false">Close</el-button>
				<el-button type="primary" @click.native="handleAddProduct" :loading="loading">Submit</el-button>
			</div>
		</el-dialog>

		<el-dialog title="Offer Detail" width="80%" :visible.sync="offerDetailVisible" :close-on-click-modal="false">
			<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
				<el-form :inline="true" :model="filters">
					<el-form-item>
						<el-select v-model="filters.offerDetailFilter" placeholder="User" @change="getOfferDetail()" clearable>
							<el-option v-for="(nurse,index) in nurseList" :label="nurse.username" :value="nurse.userNo" :key="index"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</el-col>
			<el-table stripe :data="offerDetails" highlight-current-row v-loading="listLoading" @selection-change=""
					  style="width: 100%;">
				<el-table-column prop="id" label="#">
				</el-table-column>
				<el-table-column prop="productName" label="Product" >
				</el-table-column>
				<el-table-column prop="user" label="User" >
				</el-table-column>
				<el-table-column prop="price" label="Price" >
				</el-table-column>
				<el-table-column label="Warehouse" >
					<template slot-scope="scope">
						<p v-if="scope.row.isDoctor==0"><i class="fa fa-university"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
						<p v-if="scope.row.isDoctor==1"><i class="fa fa-user"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
					</template>
				</el-table-column>
				<el-table-column prop="quantity" label="Qty" >
				</el-table-column>
				<el-table-column prop="takeDate" label="Offer Take Date" >
				</el-table-column>
			</el-table>
			<el-col :span="24" class="toolbar">
				<el-pagination layout="prev, pager, next" @current-change="handleChangeOfferDetail"
							   :page-size="pageSize" :total="offerDetailTotal" style="float:right;">
				</el-pagination>
			</el-col>
			<div slot="footer" class="dialog-footer">
				<el-button type="" @click.native="offerDetailVisible=false">Close</el-button>
			</div>
		</el-dialog>

		<!-- Offer认领详情对话框 -->
		<el-dialog title="Offer Claim Details" width="50%" :visible.sync="claimDetailVisible" :close-on-click-modal="false">
			<div v-if="claimDetails" style="margin-bottom: 20px;">
				<!-- Offer基本信息 -->
				<el-card class="box-card" style="margin-bottom: 15px;">
					<div slot="header" class="clearfix">
						<span style="font-weight: bold; font-size: 16px;">Offer Information</span>
					</div>
					<el-row :gutter="20">
						<el-col :span="8">
							<p><strong>Offer #:</strong> {{ claimDetails.offerNo }}</p>
							<p><strong>Product:</strong> {{ claimDetails.productName }}</p>
							<p><strong>UPC:</strong> {{ claimDetails.upc }}</p>
						</el-col>
						<el-col :span="8">
							<p><strong>Price:</strong> ${{ claimDetails.price }}</p>
							<p><strong>Total Qty:</strong> {{ claimDetails.totalQuantity }}</p>
							<p><strong>Left Qty:</strong> {{ claimDetails.leftQuantity }}</p>
						</el-col>
						<el-col :span="8">
							<p><strong>Status:</strong> {{ claimDetails.status }}</p>
							<p><strong>Claimed Records:</strong> {{ claimDetails.totalClaimedRecords }}</p>
							<p><strong>Claimed Qty:</strong> {{ claimDetails.totalClaimedQuantity }}</p>
						</el-col>
					</el-row>
				</el-card>

				<!-- 认领时间统计 -->
				<el-card class="box-card" style="margin-bottom: 15px;" v-if="claimDetails.firstClaimTime">
					<div slot="header" class="clearfix">
						<span style="font-weight: bold; font-size: 16px;">Claim Statistics</span>
					</div>
					<el-row :gutter="20">
						<el-col :span="12">
							<p><strong>First Claim Time:</strong> {{ claimDetails.firstClaimTime }}</p>
						</el-col>
						<el-col :span="12">
							<p><strong>Last Claim Time:</strong> {{ claimDetails.lastClaimTime }}</p>
						</el-col>
					</el-row>
				</el-card>

				<!-- 认领详情表格 -->
				<el-card class="box-card">
					<div slot="header" class="clearfix">
						<span style="font-weight: bold; font-size: 16px;">Claim Records</span>
					</div>
					<el-table stripe :data="claimDetails.claimRecords" highlight-current-row v-loading="claimDetailLoading" style="width: 100%;">
						<el-table-column prop="inboundNo" label="Inbound #" width="90">
						</el-table-column>
						<el-table-column label="Nurse" width="120">
							<template slot-scope="scope">
								{{ scope.row.nurseName }}
							</template>
						</el-table-column>
						<el-table-column prop="tracking" label="Tracking #" width="250" show-overflow-tooltip>
						</el-table-column>
						<el-table-column prop="claimedQuantity" label="Qty" width="45" align="center">
						</el-table-column>
						<el-table-column prop="claimTime" label="Claim Time" width="160">
						</el-table-column>
						<el-table-column label="Warehouse" show-overflow-tooltip>
							<template slot-scope="scope">
								<span v-if="scope.row.warehouseState && scope.row.warehouseCity && scope.row.warehouseAddress">
									{{ scope.row.warehouseState }}, {{ scope.row.warehouseCity }}, {{ scope.row.warehouseAddress }}
								</span>
								<span v-else-if="scope.row.warehouseAddress">
									{{ scope.row.warehouseAddress }}
								</span>
								<span v-else>
									Warehouse #{{ scope.row.warehouseNo }}
								</span>
							</template>
						</el-table-column>
						<el-table-column label="UPC Check" width="100">
							<template slot-scope="scope">
								<div v-if="scope.row.isUpcMismatch === true" style="color: #F56C6C;">
									<i class="el-icon-warning"></i> Mismatch
								</div>
								<div v-else-if="scope.row.isUpcMismatch === false" style="color: #67C23A;">
									<i class="el-icon-circle-check"></i> Matched
								</div>
								<div v-else style="color: #E6A23C;">
									<i class="el-icon-question"></i> Anomaly
								</div>
							</template>
						</el-table-column>
					</el-table>
					<!-- 分页组件 -->
					<el-col :span="24" class="toolbar" style="margin-top: 15px;">
						<el-pagination
							layout="prev, pager, next"
							@current-change="handleChangeClaimDetail"
							:page-size="claimDetailPageSize"
							:total="claimDetailTotal"
							:current-page="claimDetailPage"
							style="float:right;">
						</el-pagination>
					</el-col>
				</el-card>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button type="" @click.native="claimDetailVisible=false">Close</el-button>
			</div>
		</el-dialog>
	</section>
</template>


<script>
	import { quillEditor } from 'vue-quill-editor'
	import util from '../../common/js/util'
	import {defaultPageSize} from "../../globalVar";
    import { getOpenOffers ,getOfferDetail,getDoctorOffer,getOfferById,editOfferStatus,addOffer,getProposedOffers,editProposedOfferStatus,getTakeOfferDetail,getOfferClaimDetails} from '../../api/offerService';
	import {getInventory,getDoctorProduct} from "../../api/inventoryService";
	import {addProduct} from "../../api/inventoryService";
	import {getDoctorMemberList,getMemberWithGroup,getDoctorNurse} from "../../api/memberService";
	import {exportExcel} from "../../api/exportService";
	import {conditions} from "../../globalVar";
    import ElOption from "element-ui/packages/select/src/option";

	export default {
        components: {ElOption},
        data() {
			return {
				editorOption: {
					theme: "snow", // or 'bubble'
					placeholder: "Note",
					height:"400px",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
								["link"] // 链接、图片、视频
							]
						}
					}
				},
				relistFormVisible:false,
				offerDetailVisible:false,
                offerHistory:[],
                proposedOffers:[],
				offerDetails:[],

				// Offer认领详情相关
				claimDetailVisible: false,
				claimDetailLoading: false,
				claimDetails: null,
				claimDetailPage: 1,
				claimDetailPageSize: 50,
				claimDetailTotal: 0,
				currentOfferNo: "",
				conditions:conditions,
				activeName:"first",
				filters: {
				    offerDetailFilter:"",
				    historyFilter:"",
                    proposedFilter:"",
				    openOfferFilter:"",
					name: '',
                    status:""
				},
                currentDetailNo:"",

				products:[],
				openOffers: [],

				nurseList:[],

				pageSize:defaultPageSize,
				total: 0,
				page: 1,

				offerDetailPage:1,
				offerDetailTotal:0,

                historyPage:1,
                historyTotal:0,

                proposedPage:1,
                proposedTotal:0,

				openOfferPage:0,
				openOfferTotal:0,

				loading:false,
				listLoading:false,
				firstListLoading: false,
				secondListLoading:false,
				thirdListLoading:false,

				groups:[],

				addProductVisible:false,
				inputVisible:false,
				inputValue:"",

				editFormVisible: false,//编辑界面是否显示
				editOffer:{},
				relistOffer:{
                    newExpireDate:""
				},
				editLoading: false,

				editOfferFormRules:{
                    productNo: [
                        {required: true, message: 'Product is required.', trigger: 'blur'}
                    ],
                    price: [
                        {required: true, message: 'Price is required.', trigger: 'blur'}
                    ],
                    quantity: [
                        {required: true, message: 'Original Total is required.', trigger: 'blur'}
                    ],
                    leftNum: [
                        {required: true, message: 'Left is required.', trigger: 'blur'}
                    ],
                    expireDate: [
                        {required: true, message: 'Expire Date is required.', trigger: 'blur'}
                    ],
                    bouns: [
                        {required: true, message: 'Bonus is required.', trigger: 'blur'}
                    ]
				},

                addOfferFormRules:{
                    productNo: [
                        {required: true, message: 'Product is required.', trigger: 'blur'}
                    ],
                    price: [
                        {required: true, message: 'Price is required.', trigger: 'blur'}
                    ],
                    total: [
                        {required: true, message: 'Total is required.', trigger: 'blur'}
                    ],
                    expireDate: [
                        {required: true, message: 'Expire Date is required.', trigger: 'blur'}
                    ],
                    bouns: [
                        {required: true, message: 'Bonus is required.', trigger: 'blur'}
                    ]
                },

                addProductFormRules: {
                    product: [
                        {required: true, message: 'Product Name is  required.', trigger: 'blur'}
                    ],
					price: [
						{required: true, message: 'Price is required.', trigger: 'blur'}
					]
                },

                addProduct: {
                    id: "",
                    product: '',
                    condition: "New",
                    price: "",
                    asin: "",
                    upc: "",
                    weight: '',
                    note: ""
                },

				addFormVisible: false,//新增界面是否显示
				addLoading: false,
				addFormRules: {
					name: [
						{ required: true, message: '请输入姓名', trigger: 'blur' }
					]
				},
				//新增界面数据
				addOffer: {
					id:"",
					title:"",
					productNo: '',
					price: "",
					total:0,
                    expireDate: '',
					note: '',
                    bouns:"",
					scope:"public",
					notify:true,
					users:[]
				},
				defaultProps: {
					children: 'members',
					label: 'label'
				},
				dateOption:{
                    disabledDate(date){
                        return date.getTime()<Date.now()-8.64e7;
                    }
                },
			}
		},
		methods: {

			exportExcel(url,fileName){
				let param = {
					url:url,
					fileName:fileName
				}
				exportExcel(param).then(function(){

				})
			},
            getNurseList(){
                getDoctorNurse().then((data)=>{
                    if(data.status===200){
						this.nurseList = data.result;
                    }
                })
            },
            getOfferDetail(id){
                if(id){
                    this.currentDetailNo = id;
				}
                let param = {
                    offerNo:id?id:this.currentDetailNo,
                    current:this.offerDetailPage,
                    size:this.pageSize,
                    userNo:this.filters.offerDetailFilter
                }
                this.listLoading = true;
                getTakeOfferDetail(param).then((data)=>{
                    this.listLoading = false;
                    if(data.status===200){
                        this.offerDetails = data.result.records;
                        this.offerDetailTotal = data.result.total;
                        this.offerDetailVisible = true;
                    }else{
                        this.$message.error(data.messaeg);
                    }
                })
            },
            confirmProposed(id,status){
                this.$confirm('Are you sure?', 'Warning', {
                    type: 'warning'
                }).then(() => {
                    editProposedOfferStatus({id:id,status:status}).then((res)=>{
                        if(res.status===200){
                            this.$message.success(res.message);
                            this.getProposedOffers();
                        }else{
                            this.$message.error(res.message);
                            this.getProposedOffers()
                        }
                    })
                }).catch(() => {

                });
            },
            getProposedOffers(){
                let param = {
                    current:this.proposedPage,
                    size:this.pageSize,
                    condition:this.filters.proposedFilter,
					status:this.filters.status
                }
                this.secondListLoading = true;
                getProposedOffers(param).then((data)=>{
                    this.secondListLoading = false;
                    if(data.status===200){
                        this.proposedOffers = data.result.records;
                        this.proposedTotal = data.result.total;
                    }
                })
            },
            formatProposedStatus(row,column){
                if(row.status===0){
                    return "Pending";
                }else if(row.status===1){
                    return "Confirmed";
                }else if(row.status===3){
                    return "Cancelled";
                }else {
                    return "Rejected"
                }
            },
            getMembers(){
                getMemberWithGroup().then((res)=>{
                	console.log(res);
                    if(res.status===200){
                        let groups = [];
                        let unGroup = {label:"No Group",members:[]};
                        res.result.forEach((item)=>{
                            if(item.groupName){
                                let result = groups.find((group)=>{
                                    return item.groupName === group.label;
                                });
                                if(result){
                                    result.members.push({label:item.userName,userNo:item.userNo});
                                }else{
                                    groups.push({label:item.groupName,members:[{label:item.userName,userNo:item.userNo}]});
                                }
							}else{
                                unGroup.members.push({label:item.userName,userNo:item.userNo});
							}

						});
                        if(unGroup.members.length>0){
                            groups.unshift(unGroup);
						}
                        this.groups =groups;
					}
				})
			},
            archiveOffer(offerId){
                this.$confirm('Are you sure?', 'Warning', {
                    type: 'warning'
                }).then(() => {
                    editOfferStatus({offerNo:offerId,status:'archived'}).then((res)=>{
                        if(res.status===200){
                            this.$message.success(res.message);
                            this.getOpenOffers();
                            this.getOfferHistory();
                        }else{
                            this.$message.error(res.message);
                        }
                    })
                }).catch(() => {

                });

			},
			getProductList(){
                getDoctorProduct({condition:""}).then((res)=>{
                    if(res.status===200){
						this.products = res.result;
					}
				})
			},
		    showAddProduct(){
                var temp = new Date();
                temp.setDate(temp.getDate()+3);
                this.addOffer.expireDate = util.formatDate.format(temp,'yyyy-MM-dd hh:mm:ss')
		        getDoctorMemberList({roleId:2}).then((res)=>{
		            if(res.status===200){
		                this.addFormVisible= true;
		                this.members = res.result;
					}
				})
			},
            handleAddProduct () {
                this.$refs.addProduct.validate((valid) => {
                    if (valid) {
                        let param = {
                            productName:this.addProduct.product,
                            condition:this.addProduct.condition,
                            asin:this.addProduct.asin,
                            upc:this.addProduct.upc,
                            weight:this.addProduct.weight,
                            note:this.addProduct.note,
							price:this.addProduct.price
                        };
                        this.loading = true;
                        addProduct(param).then((res)=>{
                            this.loading = false;
                            if(res.status===200){
                                this.$message({
                                    message:res.message,
                                    type:"success"
                                });
                                this.$refs.addProduct.resetFields();
                                this.addProductVisible = false;
                                this.getProductList();
                            }else {
                                this.$message({
                                    message:res.message,
                                    type:"error"
                                })
                            }
                        })
                    }
                });
            },
            handleChangeOfferDetail(val) {
                this.offerDetailPage = val;
                this.getOfferDetail();
            },
            handleChangeOfferHistory(val) {
                this.historyPage = val;
                this.getOfferHistory();
            },
            handleChangeOpenOffer(val) {
                this.openOfferPage = val;
                this.getOpenOffers();
            },
			handleCurrentChange(val) {
				this.page = val;
				//this.getUsers();
			},
			getOpenOffers() {
				let param = {
					current: this.openOfferPage,
					size:this.pageSize,
					condition: this.filters.openOfferFilter,
					status:"offering"
				};
				this.firstListLoading = true;
                getDoctorOffer(param).then((res) => {
                    this.firstListLoading = false;
                    if(res.status===200){
                        this.openOffers = res.result.records;
                        this.openOfferTotal = res.result.total;
					}else{
                        this.$message.error(res.message);
					}

				});
			},
            getOfferHistory() {
                let param = {
                    current: this.historyPage,
                    size:this.pageSize,
                    condition: this.filters.historyFilter,
                    status:this.filters.status
                };
                this.thirdListLoading = true;
                getDoctorOffer(param).then((res) => {
                    this.thirdListLoading = false;
                    if(res.status===200){
                        this.offerHistory = res.result.records;
                        this.historyTotal = res.result.total;
                    }else{
                        this.$message.error(res.message);
                    }

                });
            },
			showEditOffer: function (offerId) {
                getOfferById({offerNo:offerId}).then((res)=>{
                    if(res.status===200){
                        this.editFormVisible = true;
                        this.editOffer =  res.result.offer;
                        if(res.result.offerUsers){
                        	let users = res.result.offerUsers.split(",");
                        	this.editOffer.users = users;
						}
					}
				});
			},
			reListOffer: function (offerId) {
				getOfferById({offerNo:offerId}).then((res)=>{
					if(res.status===200){
						this.relistFormVisible = true;
						this.relistOffer =  res.result.offer;
                        var temp = new Date();
                        temp.setDate(temp.getDate()+3);
                        // this.relistOffer.newExpireDate = util.formatDate.format(temp,'yyyy-MM-dd hh:mm:ss')
						this.$set(this.relistOffer,"newExpireDate",util.formatDate.format(temp,'yyyy-MM-dd hh:mm:ss'))
						if(res.result.offerUsers){
							let users = res.result.offerUsers.split(",");
							this.relistOffer.users = users;
						}
					}
				});
			},
			handleAddOffer(){
                this.$refs.addOffer.validate((valid)=>{
                    if(valid){
                        this.loading= true;
                        let param = {
                            productNo:this.addOffer.productNo,
                            price:this.addOffer.price,
                            quantity:this.addOffer.total,
							leftNum:this.addOffer.total,
                            expireDate:this.addOffer.expireDate,
                            bouns:this.addOffer.bouns,
							scope:this.addOffer.scope,
							note:this.addOffer.note,
                            notify:this.addOffer.notify
                        };
                        if(this.addOffer.scope==="private"){
							let checked = this.$refs.tree.getCheckedKeys();
							if(checked.length>0){
								checked = checked.filter((item)=>{
									return item!==undefined;
								})
							}
							let array = Array.from(new Set(checked));
							param.nurseStr = array.join(",");
                            // param.nurseStr = this.addOffer.users.join(",")
						}
                        addOffer(param).then((res)=>{
                            this.loading= false;
                            if(res.status===200){
                                this.addFormVisible = false;
                                this.$message.success(res.message);
                                this.$refs.addOffer.resetFields();
                                this.getOpenOffers();
                            }else{
                                this.$message.error(res.message);
                            }
                        })
                    }
                })
			},
			handleEditOffer () {
                this.loading= true;
				this.$refs.editOffer.validate((valid)=>{
                    this.loading= false;
				    if(valid){
				        let param = {
                            offerNo:this.editOffer.offerNo,
                            price:this.editOffer.price,
                            quantity:this.editOffer.quantity,
                            leftNum:this.editOffer.leftNum,
                            expireDate:this.editOffer.expireDate,
                            bouns:this.editOffer.bouns,
                            scope:this.editOffer.scope,
                            notify:this.editOffer.notify,
							note:this.editOffer.note
						};
                        addOffer(param).then((res)=>{
                            if(res.status===200){
                                this.editFormVisible = false;
                                this.$message.success(res.message);
                                this.getOpenOffers();
								this.getOfferHistory();
							}else{
                                this.$message.error(res.message);
							}
						})
					}
				})
            },
			handleReListOffer () {
				this.loading= true;
				this.$refs.relistOffer.validate((valid)=>{
					this.loading= false;
					if(valid){
						let param = {
							offerNo:this.relistOffer.offerNo,
							price:this.relistOffer.price,
							quantity:this.relistOffer.quantity,
							leftNum:this.relistOffer.leftNum,
							expireDate:this.relistOffer.newExpireDate,
							bouns:this.relistOffer.bouns,
							scope:this.relistOffer.scope,
							notify:this.relistOffer.notify,
							note:this.relistOffer.note,
							status:"offering"
						};
						addOffer(param).then((res)=>{
							if(res.status===200){
								this.relistFormVisible = false;
								this.$message.success(res.message);
								this.getOpenOffers();
								this.getOfferHistory();
							}else{
								this.$message.error(res.message);
							}
						})
					}
				})
			},

			/**
			 * 显示Offer认领详情
			 */
			showOfferClaimDetails(offerNo) {
				this.currentOfferNo = offerNo;
				this.claimDetailPage = 1;
				this.claimDetailVisible = true;
				this.getOfferClaimDetails();
			},

			/**
			 * 获取认领详情数据
			 */
			getOfferClaimDetails() {
				this.claimDetailLoading = true;

				const params = {
					offerNo: this.currentOfferNo,
					current: this.claimDetailPage,
					size: this.claimDetailPageSize
				};

				// 调用后端API获取认领详情
				getOfferClaimDetails(params).then((res) => {
					this.claimDetailLoading = false;
					if (res.status === 200) {
						this.claimDetails = res.result;
						// 设置分页总数
						if (res.result.total !== undefined) {
							this.claimDetailTotal = res.result.total;
						} else {
							// 如果没有total字段，使用claimRecords的长度作为fallback
							this.claimDetailTotal = res.result.claimRecords ? res.result.claimRecords.length : 0;
						}
					} else {
						this.$message.error(res.message || '获取认领详情失败');
						this.claimDetailVisible = false;
					}
				}).catch((error) => {
					this.claimDetailLoading = false;
					this.$message.error('获取认领详情失败: ' + error.message);
					this.claimDetailVisible = false;
				});
			},

			/**
			 * 处理认领详情分页变化
			 */
			handleChangeClaimDetail(page) {
				this.claimDetailPage = page;
				this.getOfferClaimDetails();
			}
		},
		mounted() {
			this.getOpenOffers();
			this.getProductList();
			this.getMembers();
			this.getProposedOffers();
			this.getOfferHistory();
			this.getNurseList();
			let active = this.$route.params.active;
			if(active){
				this.activeName = active;
			}
		}
	}

</script>

<style>
	.el-tag{
		margin: 5px;
	}
</style>


// WEBPACK FOOTER //
// offer.vue?e2e4533e